/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Border_OnInputs */

const fr_label_border_on = /** @type {(inputs: Label_Border_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activées`)
};

const en_label_border_on = /** @type {(inputs: Label_Border_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled`)
};

/**
* | output |
* | --- |
* | "Enabled" |
*
* @param {Label_Border_OnInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const label_border_on = /** @type {((inputs?: Label_Border_OnInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Border_OnInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_label_border_on(inputs)
	return en_label_border_on(inputs)
});